import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/my-account.png";
import full02 from "../assets/images/fulls/messages.png";


import thumb01 from "../assets/images/fulls/my-account.png";
import thumb02 from "../assets/images/fulls/messages.png";



const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
];

const SportsConnectMyAccount = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Sports Connect My Account UI/UX</title>
        </Helmet>
        <div id="main">
    <h1>Sports Connect My Account UI/UX</h1>
    <p>I designed a user interface update to Sports Connect's My Account so it would closer match the registration process app. The backend for the My Account page was vastly different than the registration app backend, but having a consistent design between the two would make the transition feel seamless. These screens were made in Adobe XD and used the material design system with Sports Connect branding.</p>
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnectMyAccount;
